import { formatHKD, type RemediationPlan } from "./pricing";

/**
 * The priced card under "Your remediation plan".
 *
 * One fixed rate rather than a choice of tiers, so it's static — no selected
 * outline and no `aria-pressed`; the choice is the year count above it. Same
 * glow and type scale as the selectable plan cards.
 */
export function RemediationPlanCard({ plan }: { plan: RemediationPlan }) {
  return (
    <div className="relative flex w-full flex-col items-start gap-4 overflow-hidden rounded-[28px] bg-[#0F1319] p-6 sm:rounded-[32px] sm:p-8">
      <div
        aria-hidden
        className="pointer-events-none absolute -bottom-20 -left-10 h-[171px] w-[171px] rounded-full bg-[#70A6FF] blur-[72px]"
      />

      <div className="relative flex w-full flex-col items-start gap-1">
        <span className="font-inter text-xl font-bold text-white sm:text-[22px]">{plan.name}</span>
        <span className="font-inter text-sm leading-[19.6px] text-[#9C9C9C]">
          {plan.description}
        </span>
      </div>

      {/* The exports run the period and the per-year note together in one span;
          kept as two lines so the note reads as the qualifier it is. */}
      <div className="relative">
        <span className="font-inter text-2xl font-extrabold text-white sm:text-[27.53px]">
          {formatHKD(plan.price)}
        </span>
        <span className="font-inter text-base font-normal text-white">{plan.period}</span>
        <span className="block font-inter text-base font-normal text-white">
          {plan.periodNote}
        </span>
      </div>
    </div>
  );
}
